module.exports = __webpack_public_path__ + "img/0Q3A6078_L_BlackMatted_MockedUp.bebe50bc.jpg";